var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.6515,
    stroke: "#0080B1",
    strokeWidth: 0.69697
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8112 12.5474H23.1157C23.8894 12.5474 24.5271 13.1851 24.5271 13.9587V15.506C24.5271 16.0705 24.1716 16.771 23.8266 17.1265L20.7948 19.8028C20.3767 20.1583 20.0943 20.8587 20.0943 21.4233V24.4551C20.0943 24.8733 19.8121 25.4378 19.4566 25.6574L18.4739 26.2951C17.5539 26.8596 16.2889 26.2219 16.2889 25.0928V21.3605C16.2889 20.8692 16.0066 20.2315 15.7244 19.876L13.048 17.0533C12.6925 16.6978 12.4103 16.0705 12.4103 15.6419V14.0215C12.3998 13.1851 13.0375 12.5474 13.8112 12.5474Z",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 23.0039V26.1403C12.4004 31.3676 14.4913 33.4585 19.7186 33.4585H25.9913C31.2186 33.4585 33.3095 31.3676 33.3095 26.1403V19.8676C33.3095 16.6058 32.494 14.5567 30.6017 13.4903C30.0685 13.1871 29.0022 12.9571 28.0299 12.8003",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9004 24.0498H29.1277",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8086 28.2317H29.1268",
    stroke: "#0080B1",
    strokeWidth: 1.25455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleFilter);
export default __webpack_public_path__ + "static/media/icon-circle-filter.d1d9ce8d8fe51f02979a4b0b26422bef.svg";
export { ForwardRef as ReactComponent };